import React from 'react'
import {
  FieldAddress,
  FieldAssignments,
  FieldBool,
  FieldButton,
  FieldCheckbox,
  FieldColor,
  FieldDatetime,
  FieldDatetimeRange,
  FieldDivider,
  FieldText,
  FieldTextArea,
  FieldEmail,
  FieldRadio,
  FieldDropdown,
  FieldDatalist,
  FieldTime,
  FieldTimeRange,
  FieldNumber,
  FieldNumberRange,
  FieldTel,
  FieldFile,
  FieldMarkdown,
  FieldIframe,
  FieldFetch,
  FieldSearch,
  FieldSelect,
  FieldTags,
  FieldDisplay,
} from 'components/fields'


export default function Field(props) {
  if (!props.type) {
    return <FieldText {...props} />
  }
  
  switch (props.type) {
    case "text":
      return <FieldText {...props} />
    case "textarea":
      return <FieldTextArea {...props} />
    case "email":
      return <FieldEmail {...props} />
    case "address":
      return <FieldAddress {...props} />
    case "radio":
      return <FieldRadio {...props} />
    case "checkbox":
      return <FieldCheckbox {...props} />
    case "dropdown":
      return <FieldDropdown {...props} />
    case "dropdown_api":
      return <FieldFetch {...{ ...props, type: "dropdown" }} />
    case "datalist":
      return <FieldDatalist {...props} />
    case "datalist_api":
      return <FieldFetch {...{ ...props, type: "datalist" }} />
    case "datetime": // Does have timezone
    case "datetime_date": // Does have timezone
    case "date": // Does NOT have timezone
      return <FieldDatetime {...props} />
    case "datetime_time": // Does have timezone
    case "time": // Does NOT have timezone
      return <FieldTime {...props} />
    case "number":
    case "int":
      return <FieldNumber {...props} />
    case "float":
      return <FieldNumber {...{ step: ".01", ...props }} />
    case "bool":
    case "boolean":
      return <FieldBool {...props} />
    case "tel":
      return <FieldTel {...props} />
    case "color":
      return <FieldColor {...props} />
    case "markdown":
      return <FieldMarkdown {...props} />
    case "iframe":
      return <FieldIframe {...props} />
    case "file":
      return <FieldFile {...props} />
    case "search":
      return <FieldSearch {...props} />
    case "select":
      return <FieldSelect {...props} />
    case "display":
      return <FieldDisplay {...props} />
    case "divider":
      return <FieldDivider {...props} />
    // Range Fields
    case "datetime_range": // Does have timezone
    case "datetime_date_range": // Does have timezone
    case "date_range": // Does NOT have timezone
      return <FieldDatetimeRange {...props} />
    case "datetime_time_range": // Does have timezone
    case "time_range": // Does NOT have timezone
      return <FieldTimeRange {...props} />
    case "number_range":
    case "int_range":
      return <FieldNumberRange {...props} />
    case "float_range":
      return <FieldNumberRange {...{ step: ".01", ...props }} />
    case "tags":
      return <FieldTags {...props} />
    case "assignments":
      return <FieldAssignments {...props } />
    case "button":
      return <FieldButton {...props} />
    // Defaults
    default:
      if (props.type) {
        console.error("Field Error: '" + props.type + "' is not a valid field type.")
      }
      return <FieldText {...props} />
  }
}
